<template>
  <EuiAlert :color="alert.type"
            @click:close="closeAlert" :closable="alert.type !== 'success'">
      {{ alert.message }}
  </EuiAlert>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DefaultAlert',
  props: {
    alert: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      storeRemoveAlert: 'application/removeAlert',
    }),
    closeAlert() {
      this.$emit('close-alert');
    },
  },
  mounted() {
    if (this.alert.mode === 'automatic') {
      setTimeout(this.closeAlert, 30000);
    }
  },
};
</script>
